import React from 'react';
import c from '../w.js';

const IconTableSortAscending = React.memo(
  c(/* @__PURE__ */ React.createElement("path", { d: "M12.3529 9L6 15H18L12.3529 9Z" }))
);

export { IconTableSortAscending };
